<template>
<!-- FAQ -->


<template v-if="visible == false">
  
  <LoadPrices v-if="idPresupuesto"
    :idPresupuesto="idPresupuesto"
    :urlPresupuestos="urlPresupuestos"
    :conversionValue=conversionValue
    :name="name"
    :PeriodoSeleccionado="periodoCambiar"
    :PeriodosEscritos="PeriodosEscritos"
    @PonerVisible="PonerVisible"
    >
  </LoadPrices>



</template>

<template v-else>

  
    <Comparador
      :title="titulo"
      :subtitle="subtitulo"
      :products="PricingMatrix"
      :filter="filter"
      :quotation="$store.state.quotation"
      :UrlDescargaPresupuesto="UrlDescargaPresupuesto"
      :productoAnterior="productoAnterior"
      :numeroColumnasMaximo="numeroColumnasMaximo"
      :idPresupuesto="idPresupuesto"
      :trackingUrlSave="trackingUrlSave"
      :urlActiveCampaign="urlActiveCampaign"
      :ProductoSeleccionadoEnParrilla="ProductoSeleccionadoEnParrilla"
      :AddonsSeleccionados="AddonsSeleccionados"
      :PeriodoSeleccionado="periodoCambiar"
      :PeriodosEscritos="PeriodosEscritos"
      :mostrarInfo="mostrarInfo"
      @CambiarPeriodoSeleccionado="CambiarPeriodoSeleccionado"

      >
    </Comparador>


  
</template>


</template>

<script>


import LoadPrices from './LoadPrices.vue'
import Comparador from './ParrillaComparador/Comparador.vue'



export default {
  name: 'ParrillaLista',
  components : {LoadPrices, Comparador},
  data: function () {
              return {
                visible: false,
                NombreTomador: "amigo",
                UrlDescargaPresupuesto: "",
                UrlContratacion: "/contratacion-online/",
                titulo: titulo,
                subtitulo: subtitulo,
                periodoCambiar: ""
              }
            },
  props: {

    Precios : Array,
    idPresupuesto: String,
    urlPresupuestos: String,
    productoAnterior: Boolean,
    PricingMatrix: Array,
    PeriodoSeleccionado: String,
    trackingUrlSave: String,
    urlActiveCampaign: String,
    conversionValue: Number,
    name: String,
    ProductoSeleccionadoEnParrilla: String,
    AddonsSeleccionados: Array,
    filter: Array,
    numeroColumnasMaximo: Number,
    UrlDescargaPresupuesto: String,
    mostrarInfo: Boolean,
    PeriodosEscritos: Object
    
  },

  mounted: async function(){


    if (this.periodoCambiar == "")
    {

      this.periodoCambiar = this.PeriodoSeleccionado;


    }



    if (!this.idPresupuesto) {

        this.visible = true;


    }



  },

  methods: {

      CambiarPeriodoSeleccionado : function(Periodo){

        this.visible = false;

        this.periodoCambiar = Periodo;

      },



      PonerVisible : function(Visible){

        this.visible = Visible;

      }

  }
  
}
</script>


<style>

  .cardFormaPago {
    width:30%;
    margin: 0 auto;
    min-width: 200px;
  }

</style>

